const LevelsTableColumns = [
    { id: 'code', labelAr: 'الكود', labelEn: 'Code', width: 90 },
    { id: 'name', labelAr: 'اسم المستوى', labelEn: 'Level Name' },
    { id: 'academic_term_name', labelAr: 'الفصل الدراسي', labelEn: 'Academic Term' },
    { id: 'academic_year_name', labelAr: 'السنة', labelEn: 'Year', width: 130 },
    { id: 'age_from', labelAr: 'العمر من', labelEn: 'Age From', width: 90 },
    { id: 'age_to', labelAr: 'العمر إلى', labelEn: 'Age To', width: 90 },
    { id: 'is_active', labelAr: 'الحالة', labelEn: 'Status', width: 100 },
];

export default LevelsTableColumns;
